// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_MESSAGE_YOU_GAVE_REVIEW_LINK_LABEL = "hodnotenie";
export const BZ2_MESSAGE_YOU_GAVE_REVIEW_TO_link = "Pridala si %(link)s";
export const BZ2_MESSAGE_YOU_GOT_REVIEW_FROM_link = "ti pridala %(link)s";
export const BZ2_MESSAGE_YOU_GOT_REVIEW_LINK_LABEL = "hodnotenie";
